import styled, { keyframes } from 'styled-components/macro';
import { Icon } from '~/components';

const placeholderAnimation = keyframes`
  0%{
    opacity: 1;
  }
  50%{
    opacity: .3;
  }
  100%{
    opacity: 1;
  }
`;
/*
const appear = keyframes`
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
`;
*/

export const Container = styled.div`
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
  ${({ fixedColumn }) =>
    fixedColumn
      ? `
        max-width: 100%;
        overflow-x: auto;
      `
      : ``}
  table {
    border-spacing: 0;
    width: ${props => (props.fullWidth ? '100%' : 'auto')};
    border-style: none;
    background-color: ${props =>
      props.backgroundColor ? props.backgroundColor : 'transparent'};
    thead {
      font-size: 9px;
      @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
        height: 50px;
      }
      th {
        color: ${({ textHeaderColor, theme }) => textHeaderColor || theme.dark};
        background-color: ${props =>
          props.headerColor ? props.headerColor : 'transparent'};
        ${({ fixedHeader }) => {
          if (fixedHeader)
            return `
                &:first-child {
                  position: sticky;
                  top: 0px;
                  z-index: 1;
                }
              `;
          return null;
        }}
        ${({ fixedColumn, theme }) => {
          if (fixedColumn)
            return `
                &:first-child {
                  position: sticky;
                  left: 0px;
                  z-index: 1;
                  border-right: solid 1px ${theme.darkWithLowOpacity}
                }
              `;
          return null;
        }}
        & > div {
          display: flex;
          align-items: center;
        }
        @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
          ${({ responsiveHeader }) =>
            responsiveHeader
              ? `
            position: relative;
              & > div {
                position: absolute;
                max-width: 82px;
                text-align: right;
                right: 50%;
                bottom: 7px;
                transform: rotate(45deg);
                transform-origin: 100% 100%;
              }
            }
          `
              : ''}
        }
      }
    }
    tfoot tr {
      font-size: 12px;
      color: ${({ theme }) => theme.white};
      position: sticky;
      bottom: 0px;
      td {
        background-color: ${props => props.theme.dark};
        padding: 16px 6px;
        ${({ fixedColumn }) => {
          if (fixedColumn)
            return `
                &:first-child {
                  position: sticky;
                  left: 0px;
                  z-index: 1;
                }
              `;
          return null;
        }}
      }
    }
    tbody tr {
      font-size: 12px;
      color: ${props => (props.textColor ? props.textColor : props.theme.dark)};
      &:nth-child(2n -1) {
        td {
          background-color: ${props =>
            props.primaryColor ? props.primaryColor : 'transparent'};
        }
      }
      &:nth-child(2n) {
        td {
          background-color: ${props =>
            props.secondaryColor ? props.secondaryColor : 'transparent'};
        }
      }
      td {
        padding: 16px 6px;
        ${({ fixedColumn, theme }) => {
          if (fixedColumn)
            return `
                &:first-child {
                  position: sticky;
                  left: 0px;
                  z-index: 1;
                  border-right: solid 1px ${theme.darkWithLowOpacity}
                }
              `;
          return null;
        }}
        & div {
        }
      }
    }
    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-style: none;
      @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
        padding: 5px;
      }
    }
  }
`;

export const IconTable = styled(Icon)`
  fill: ${props => (props.textColor ? props.textColor : props.theme.dark)};
  margin-left: 7px;
  width: 10px;
  height: 10px;
`;

export const PlaceholderData = styled.div`
  height: 10px;
  width: 80%;
  background-color: ${({ theme }) => theme.darkWithLowOpacity};
  animation: ${placeholderAnimation} 2s linear infinite;
`;
